<template>
  <div>
    <div class="skeleton-holder">
      <table border="0" class="skeleton-table" v-if="isLoading">
        <tr v-for="num of numberOfRow" :key="num">
          <td><div></div></td>
        </tr>
      </table>
      <span v-else>Keine Verknüpfung vorhanden</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TableSkeleton',
  props: {
    isLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
    numberOfRow: {
      type: Number,
      required: false,
      default: 3,
    },
  },
};
</script>

<style scoped>
.skeleton-table {
  width: 100%;
}
.skeleton-table td,
.skeleton-table tr,
.skeleton-table {
  border: 0px solid transparent !important;
}

.skeleton-table td div {
  width: 100%;
  background-color: #7e8890;
  padding: 15px;
  border-radius: 4px;
  background: linear-gradient(to right, #f1f0f0, #c1c0c0, #f1f0f0);
  background-size: 200%;
  background-position: left;
  animation: load 1s ease-out 0s infinite normal;
}
@keyframes load {
  0%,
  100% {
    background-position: right;
  }
  50% {
    background-position: left;
  }
}
</style>
